export default "__VITE_ASSET__DSRbht4e__"